<template>
    <div class="area-analysis flow-container">
        <ParamsHeader @searchParams="searchData" :data-conf="{ type: 'month' }"></ParamsHeader>
        <template v-if="searchParams">
            <Card :no-border="false" style="margin-top: 15px">
                <template #header>
                    <div class="card-header">
                        <span>流量趋势</span>
                    </div>
                </template>
                <div style="padding: 0px 20px 20px; display: flex; margin-top: 20px">
                    <div style="flex: 4; margin-right: 10px">
                        <ChartMap class="chart-normal" ref="first-chart"></ChartMap>
                    </div>
                    <div style="flex: 6">
                        <ChartMap class="chart-normal" ref="second-chart"></ChartMap>
                    </div>
                </div>
            </Card>
            <Card :no-border="false" style="margin-top: 15px">
                <template #header>
                    <div class="card-header">
                        <span>集客力和游逛深度趋势</span>
                    </div>
                </template>
                <div style="padding: 0px 20px 20px; margin-top: 20px">
                    <div>
                        <ChartMap class="chart-normal" ref="third-chart"></ChartMap>
                    </div>
                </div>
            </Card>
        </template>
    </div>
</template>

<script>
import ParamsHeader from "../components/ParamsHeader2";

export default {
    name: "type",
    components: {
        ParamsHeader,
    },
    data() {
        return {
            pieData: [],
            lineData1: [],
            lineData2: [],
            searchParams: null,
        };
    },
    methods: {
        searchData(params) {
            console.log(params, "9090909");
            let searchParams = {
                BeginTime: this.$dayjs(params.Date).startOf("month").format("YYYY-MM-DD"),
                EndTime: this.$dayjs(params.Date).endOf("month").format("YYYY-MM-DD"),
                EntityID: params.EntityID,
                ParentCategoryID: "",
            };
            this.searchParams = { ...searchParams };
            this.$ajax.post("/FlowData/GetCategoryDataTotal", searchParams).then((res) => {
                const data = res.Data;
                if (Array.isArray(data)) {
                    this.pieData = data;
                }
                this.$ajax.post("/FlowData/GetCategoryDataTotal", searchParams).then((res) => {
                    const data = res.Data;
                    if (Array.isArray(data)) {
                        this.lineData1 = data;
                    }
                    this.$ajax.post("/FlowData/GetCategoryDataTotal", searchParams).then((res) => {
                        const data = res.Data;
                        if (Array.isArray(data)) {
                            this.lineData2 = data;
                            // 构建图表
                            this.buildChart();
                        }
                    });
                });
            });
        },
        buildChart() {
            let firstChart = this.firstChart();
            console.log(firstChart);
            firstChart ? this.$refs["first-chart"].setData(firstChart) : this.$refs["first-chart"].noData();
            let secondChart = this.secondChart();
            console.log(secondChart);
            secondChart ? this.$refs["second-chart"].setData(secondChart) : this.$refs["second-chart"].noData();
            let thirdChart = this.thirdChart();
            console.log(thirdChart);
            thirdChart ? this.$refs["third-chart"].setData(thirdChart) : this.$refs["third-chart"].noData();
        },
        firstChart() {
            if (!this.pieData.length) {
                return null;
            }
            let data = this.pieData.map((item) => {
                return {
                    value: item.DataIn,
                    name: item.Name,
                };
            });
            let option = {
                color: ["#4472C4", "#70AD47", "#FFC000", "#A5A5A5", "#ED7D31", "#5B9BD5"],
                title: {
                    text: "各业态客流当期占比",
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "bottom",
                },
                series: [
                    {
                        name: "各业态客流当期占比",
                        type: "pie",
                        center: ["50%", "50%"],
                        itemStyle: {
                            borderRadius: 8,
                        },
                        data: data,
                    },
                ],
            };
            return option;
        },
        thirdChart() {
            if (!this.lineData2.length) {
                return null;
            }
            let xData = new Set(this.lineData1.map((item) => item.ChildName));
            let lData = this.lineData1.map((item) => item.Name);
            let sData = [];
            lData.forEach((label) => {
                let rows = this.lineData1.filter((item) => item.Name === label);
                let data = rows.map((row) => row.FlowDensity);
                sData.push({
                    name: label,
                    data: data,
                    type: "line",
                    smooth: true,
                });
            });
            let option = {
                color: ["#FFC000", "#ED7D31", "#5B9BD5", "#A5A5A5"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "各业态客流趋势",
                    left: "center",
                },
                legend: {
                    bottom: 0,
                    data: lData,
                },
                grid: {
                    top: 50,
                    left: "3%",
                    right: "4%",
                    bottom: 40,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: Array.from(xData),
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        name: "客流量(人次)",
                    },
                ],
                series: sData,
            };
            return option;
        },
        secondChart() {
            if (!this.lineData1.length) {
                return null;
            }
            let xData = new Set(this.lineData1.map((item) => item.ChildName));
            let lData = this.lineData1.map((item) => item.Name);
            let sData = [];
            lData.forEach((label) => {
                let rows = this.lineData1.filter((item) => item.Name === label);
                let data = rows.map((row) => row.DataIn);
                sData.push({
                    name: label,
                    data: data,
                    type: "line",
                    smooth: true,
                });
            });
            let option = {
                color: ["#FFC000", "#ED7D31", "#5B9BD5", "#A5A5A5"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "业态集客力趋势",
                    left: "center",
                },
                legend: {
                    bottom: 15,
                    data: lData,
                },
                grid: {
                    top: 50,
                    left: "3%",
                    right: "4%",
                    bottom: 50,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: xData,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: sData,
            };
            return option;
        },
    },
};
</script>

<style scoped></style>
